import consumer from "./consumer"
import CableReady from "cable_ready"
consumer.subscriptions.create("VastMachineDataChannel", {
  connected() {
    console.log("connected to vast machine channel")
  },

  disconnected() {
    // Called when the subscription has been terminated by the server
  },

  received(data) {
    if (data.cableReady) {
      // This subscription survives Turbolinks navigation to non-dashboard pages.
      const operations = data.operations.filter(operation =>
        !operation.selector || document.querySelector(operation.selector)
      )
      if (operations.length) CableReady.perform(operations)
    }
  }
});
